import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-quote-expired',
  templateUrl: './quote-expired.component.html',
  styleUrls: ['./quote-expired.component.scss'],
  standalone: false
})
export class QuoteExpiredComponent implements OnInit {
  title: string;
  isMobile: boolean;
  appStrings: AppLocalization;
  selections;
  radioValues: { label: string, value: string }[];
  element: any;
  expiredQuoteForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<QuoteExpiredComponent>,
    private appInfoService: AppInfoService,
    private fb: FormBuilder,
    private deviceService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.element = data.quote;
    this.initForm();
  }

  private initForm() {
    this.expiredQuoteForm = this.fb.group({
      option: ['1']
    });
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
    this.radioValues = [
      { label: this.appStrings.quote_expired_updatePricing, value: '1' },
      { label: this.appStrings.quote_expired_pricingApprovalReceived, value: '2' }
    ];
    this.selections = {
      updatePricing: false,
      pricingApprovalReceived: false
    };
  }

  close(sendSelections?): void {
    this.dialogRef.close(sendSelections ? this.selections : null);
  }

  confirmSelection() {
    const selectedValue = this.expiredQuoteForm.value.option;

    if (selectedValue === '1') {
      this.selections.updatePricing = true;
    } else if (selectedValue === '2') {
      this.selections.pricingApprovalReceived = true;
    }
    this.close(true);
  }

  /**
   * Check if a valid selection has been made
   */
  get hasValidSelection(): boolean {
    const selected = this.expiredQuoteForm.value.option;
    return selected && (selected === '1' || selected === '2');
  }

}
